module.exports = {
	"type": "Polygon",
	"coordinates": [
		[
			[
				0,
				90
			],
			[
				180,
				90
			],
			[
				180,
				-90
			],
			[
				0,
				-90
			],
			[
				-180,
				-90
			],
			[
				-180,
				0
			],
			[
				-180,
				90
			],
			[
				0,
				90
			]
		],
		[
			[
				-77.38616777122564,
				37.535453001554856
			],
			[
				-77.3860817411794,
				37.53567260610595
			],
			[
				-77.38593449877806,
				37.536066044212646
			],
			[
				-77.3856653739578,
				37.53677076016248
			],
			[
				-77.38553327703909,
				37.53707301600696
			],
			[
				-77.38543660171774,
				37.53731243352206
			],
			[
				-77.38543530579472,
				37.53736879043737
			],
			[
				-77.38545578155902,
				37.537415953583434
			],
			[
				-77.38549673308773,
				37.53745615777552
			],
			[
				-77.38563518821331,
				37.53755357683616
			],
			[
				-77.38578339468785,
				37.537643263525865
			],
			[
				-77.3858409216212,
				37.537670324126225
			],
			[
				-77.38595207602742,
				37.53770743554975
			],
			[
				-77.38611490817641,
				37.537745320390286
			],
			[
				-77.38622411195314,
				37.537775473759154
			],
			[
				-77.3864113193269,
				37.53781181176578
			],
			[
				-77.38656147553161,
				37.53785820149483
			],
			[
				-77.38666190462317,
				37.53790845651014
			],
			[
				-77.38678183461394,
				37.53799118424581
			],
			[
				-77.38684813713178,
				37.53806154180677
			],
			[
				-77.38687251325587,
				37.538081643453154
			],
			[
				-77.38696611739238,
				37.538202256029365
			],
			[
				-77.38700316856136,
				37.53823627468438
			],
			[
				-77.3870402197303,
				37.53824941827611
			],
			[
				-77.38707824666369,
				37.53825251104462
			],
			[
				-77.3872147520591,
				37.53822313109265
			],
			[
				-77.38744358185579,
				37.538180317967374
			],
			[
				-77.387634018695,
				37.5381537403029
			],
			[
				-77.38786863742763,
				37.53811145867695
			],
			[
				-77.38810630306341,
				37.53806072072575
			],
			[
				-77.38817181417784,
				37.53804864013267
			],
			[
				-77.3883805333349,
				37.53798823716744
			],
			[
				-77.38868827954042,
				37.53785293416564
			],
			[
				-77.38888176418203,
				37.5377393767709
			],
			[
				-77.38902802002707,
				37.53761736215159
			],
			[
				-77.38915447010265,
				37.53752313298622
			],
			[
				-77.38924740424426,
				37.53743615235658
			],
			[
				-77.38931443791097,
				37.537364876587844
			],
			[
				-77.38937537777144,
				37.53729239213027
			],
			[
				-77.38942321540901,
				37.53722962125005
			],
			[
				-77.38950280001416,
				37.53709928160663
			],
			[
				-77.3895626930638,
				37.537014012386805
			],
			[
				-77.3896315424617,
				37.53689060561703
			],
			[
				-77.38969347607303,
				37.53676489658278
			],
			[
				-77.38974837338867,
				37.53663713079902
			],
			[
				-77.38979612559069,
				37.536507558277265
			],
			[
				-77.38983664184752,
				37.53637643172698
			],
			[
				-77.38989498086863,
				37.53622470260797
			],
			[
				-77.38996080764514,
				37.53607492951443
			],
			[
				-77.39003401965425,
				37.53592734537074
			],
			[
				-77.38968344233695,
				37.53584441169028
			],
			[
				-77.38893554453972,
				37.535786731872236
			],
			[
				-77.38840749770782,
				37.53561880236589
			],
			[
				-77.38627995625495,
				37.53512034233
			],
			[
				-77.38616777122564,
				37.535453001554856
			]
		]
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/data/eastEndPerimeter.json
// module id = 187
// module chunks = 0